// extracted by mini-css-extract-plugin
module.exports = {"profileTag":"Tag_profileTag__3sCN9"};